import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2022重庆金融上游榜';
const baseUrl = '20221104JRSY';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'exhibition',
      name: `${baseUrl}-exhibition`,
      component: () => import('./pages/Exhibition.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'prize',
      name: `${baseUrl}-prize`,
      component: () => import('./pages/Prize.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'result',
      name: `${baseUrl}-result`,
      component: () => import('./pages/Result.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
